module.exports = __webpack_public_path__ + "assets/img/codeleft.17c57565.png";